import { Card } from '../../../Common/Charts/Card';
import { currency } from '../../../Common/Util/currency';
import { IndicatorValue } from './Indicator';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Indicators = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div className="d-flex flex-column flex-grow-1" style={{ gap: '10px' }}>
            <IndicatorValue />
            <Card
                title="Valor Aprovado"
                value={currency.formatToBrCurrency(
                    chartData?.indexes[0]?.valor_aprovado || 0
                )}
            />
            <Card
                title="Valor Produzido"
                value={currency.formatToBrCurrency(
                    chartData?.indexes[0]?.valor_produzido || 0
                )}
            />
            <Card
                title="Valores Totais dos Procedimentos na Tabela SIGTAP"
                value={currency.formatToBrCurrency(
                    chartData?.indexes[0]?.valor_sigtap || 0
                )}
            />
        </div>
    );
};
